import { Schemas } from "../types";

export const userPermissiblePurposes = (
  user?: Schemas["LoggedInUserDetail"]
) => {
  return user?.customer_groups?.map((group) => group.permissible_purpose) || [];
};
